import styled, { css } from 'styled-components';
import { BlackButton } from '../../../baseComponents/button';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';

export const Container = styled.div`
  margin-bottom: ${spacing.S};

  @media ${media.greaterThan('lg')} {
    max-width: 400px;
  }
`;

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXS};
  margin-bottom: ${spacing.XXS};
`;

export const Title = styled.p`
  ${TypographyStyles.Label.Large.Medium}
  color: ${colours.BLACK};
  margin: 0;
  text-transform: uppercase;
`;

export const ButtonContainer = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  user-select: none;
`;

export const FormContainer = styled.div`
  max-height: 2000px;
`;

export const PromoBoxForm = styled.form`
  display: flex;
  justify-content: space-between;
`;

export const PromoInput = styled.input<{ $isError: boolean }>`
  ${TypographyStyles.Body.Medium.Regular}
  border: 1px solid ${colours.BLACK};
  margin-right: ${spacing.XXXS};
  padding: ${spacing.XXXS} ${spacing.XXS};
  width: 100%;
  ${({ $isError }) =>
    $isError &&
    css`
      border: 1px solid transparent;
      outline: 1px solid ${colours.ERROR_PRIMARY};
      outline-offset: -1px;
    `}

  &::placeholder {
    color: ${colours.GREY};
  }
`;

export const AddButton = styled(BlackButton)`
  height: auto;
  margin: 0;
  padding: ${spacing.XXS} 27px;

  &:disabled {
    background-color: ${colours.LIGHT_GREY_2};
    color: ${colours.GREY};
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  ${TypographyStyles.Body.Tiny.Regular}
  color: ${colours.ERROR_PRIMARY};
  overflow-wrap: anywhere;
`;

export const NotificationMessage = styled.span`
  ${TypographyStyles.Body.Tiny.Regular}
  color: ${colours.SUCCESS_PRIMARY};
  overflow-wrap: anywhere;
`;

export const LozengeContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing.XXXS};
  margin-top: ${spacing.XXS};
`;

export const Lozenge = styled.div`
  ${TypographyStyles.Body.Tiny.Regular}
  align-items: center;
  background-color: ${colours.NAVY_BLUE};
  border: none;
  color: ${colours.WHITE};
  display: flex;
  max-width: fit-content;
  padding: 0 6px;
`;

export const PromoName = styled.span`
  margin: 0 7px 0 ${spacing.XXXXS};
`;
export const RemoveButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  display: flex;
  padding: 0;
  path {
    fill: ${colours.WHITE};
  }
`;

export const OrderSummaryTitle = styled.h3`
  color: ${colours.BLACK};
  margin: 0 0 20px;
  text-transform: uppercase;
  ${TypographyStyles.Headings.H3}

  @media ${media.greaterThan('lg')} {
    margin-bottom: ${spacing.S};
  }
`;
